import React from 'react';
import PropTypes from 'prop-types';

// Config
import { crudConfig } from '../../../conf/listItems';

// Components
import { MaterialIcon } from '../../../../components/MaterialIcon';
import { Dialog } from '../../../../components/Dialog';
import { DialogHeader } from '../../../../components/DialogHeader';
import { DialogBody } from '../../../../components/DialogBody';
import { DialogFooter } from '../../../../components/DialogFooter';
import { Button } from '../../../../components/Button';
import FeedbackCard from '../../../../components/FeedbackCard';

// Hooks
import { useDeleteListItem } from '../../api/hooks/useDeleteListItem';

export const DeleteListItem = ({ data, closeDialog, onDelete, sessionToken }) => {
    const [wasSuccessful, setWasSuccessful] = React.useState(false);
    const deleteListItem = useDeleteListItem({
        crudConfig,
        sessionToken,
        onSuccessCb: () => {
            setFatalError(null);
            setWasSuccessful(true);
            setTimeout(() => {
                CloseDialog();
            }, 500);
        },
        onErrorCb: (e) => {
            setFatalError(e);
            setWasSuccessful(false);
        }
    });
    const [fatalError, setFatalError] = React.useState(null);
    const [deleteData, setDeleteData] = React.useState();

    React.useEffect(() => {
        if (!deleteData) {
            setDeleteData(data);
        }
    }, [data]);

    const CloseDialog = () => {
        return typeof closeDialog === 'function' ? closeDialog() : null;
    };

    const Delete = () => {
        onDelete(data);
        CloseDialog();
        //    deleteListItem.mutate(data[crudConfig.primaryKey]);
    };

    return (
        <Dialog close={CloseDialog} size="md" visible id="list-manager-delete-list-item">
            <DialogHeader
                close={CloseDialog}
            >{`Delete ${deleteData?.adHocId} - ${deleteData?.adHocLabel}`}</DialogHeader>
            <DialogBody>
                Are you sure you wish to delete this list item?
                {fatalError != null && (
                    <FeedbackCard
                        intent={'danger'}
                        feedback={{
                            heading: `An error has occurred.`,
                            message: `Please wait a few moments before trying your request
        again.`
                        }}
                        details={fatalError}
                    />
                )}
            </DialogBody>
            <DialogFooter>
                {deleteListItem.isLoading && <div style={{ marginRight: '0.5rem' }}>Loading...</div>}
                {!deleteListItem.isLoading && wasSuccessful && (
                    <div style={{ marginRight: '0.5rem' }}>
                        <MaterialIcon icon={'done_outline'} color={'#04846D'} />
                    </div>
                )}
                <Button appearance="primary" text onClick={Delete} disabled={deleteListItem.isLoading}>
                    Delete
                </Button>
                <Button appearance="secondary" text onClick={CloseDialog}>
                    Cancel
                </Button>
            </DialogFooter>
        </Dialog>
    );
};

DeleteListItem.propTypes = {
    sessionToken: PropTypes.string.isRequired,
    data: PropTypes.object,
    closeDialog: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired
};

export default DeleteListItem;
